<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useAccountStore } from '@/store/account'
import VLayout from '@/views/Layouts/DefaultLayout.vue'
import InfoLayout from '@/views/Layouts/InfoLayout.vue'

export default defineComponent({
  name: 'FAQ',
  components: {
    VLayout,
    InfoLayout,
  },
  setup() {
    const accountStore = useAccountStore()

    const authenticated = computed(() => !!accountStore.userId)
    const isStaff = computed(() => accountStore.isStaff)

    const layout = computed(() => (authenticated.value && isStaff.value ? 'v-layout' : 'info-layout'))

    return {
      layout,
    }
  },
})
</script>
